import { useCallback } from 'react';

export interface DefaultPlausibleEvents {
  [key: string]: Record<string, any>;
}

export function usePlausible<T extends DefaultPlausibleEvents = DefaultPlausibleEvents>() {
  const trackEvent = useCallback(<K extends keyof T>(
    eventName: K,
    props?: T[K],
    debounce: number = 0
  ) => {
    if (typeof window === 'undefined' || !window.plausible) return;

    if (debounce > 0) {
      setTimeout(() => {
        window.plausible(eventName as string, { props });
      }, debounce);
    } else {
      window.plausible(eventName as string, { props });
    }
  }, []);

  return { trackEvent };
}

// Add type declaration for window.plausible
declare global {
  interface Window {
    plausible: (eventName: string, options?: { props?: Record<string, any> }) => void;
  }
} 